import { render, staticRenderFns } from "./sharePage.vue?vue&type=template&id=19d0e21c&scoped=true&"
import script from "./sharePage.vue?vue&type=script&lang=js&"
export * from "./sharePage.vue?vue&type=script&lang=js&"
import style0 from "./sharePage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./sharePage.vue?vue&type=style&index=1&id=19d0e21c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0e21c",
  null
  
)

export default component.exports